import { render, staticRenderFns } from "./correctionNotebookSeven.vue?vue&type=template&id=6a602fa6&scoped=true"
import script from "./correctionNotebookSeven.vue?vue&type=script&lang=js"
export * from "./correctionNotebookSeven.vue?vue&type=script&lang=js"
import style0 from "./correctionNotebookSeven.vue?vue&type=style&index=0&id=6a602fa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a602fa6",
  null
  
)

export default component.exports